/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1Schedule } from '../models/V1Schedule';
import { HttpFile } from '../http/http';

/**
* ListSchedulesResponse carries the page of schedules and pagination state.
*/
export class V1ListSchedulesResponse {
    /**
    * The schedules in this page.
    */
    'schedules'?: Array<V1Schedule>;
    /**
    * Total schedules available across all pages, for the filter applied.
    */
    'totalSize'?: number;
    /**
    * Token to pass as page_token on the next call. Empty when the last page has been returned.
    */
    'nextPageToken'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "schedules",
            "baseName": "schedules",
            "type": "Array<V1Schedule>",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListSchedulesResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

